import { some } from "lodash";

export const renderSmile = (type) => {
  switch (type) {
    case "excellent": {
      return <span className="qs-icon-s1"></span>;
    }
    case "positive": {
      return <span className="qs-icon-s1"></span>;
    }
    case "good": {
      return <span className="qs-icon-s2"></span>;
    }
    case "neutral": {
      return <span className="qs-icon-s3"></span>;
    }
    case "bad": {
      return <span className="qs-icon-s4"></span>;
    }
    case "unacceptable": {
      return <span className="qs-icon-s5"></span>;
    }
    case "very_bad": {
      return <span className="qs-icon-s5"></span>;
    }
    case "negative": {
      return <span className="qs-icon-s5"></span>;
    }
    default:
      return <span>No smile</span>;
  }
};

export const convertToRGBAString = (array) => {
  let color = "rgba(0,0,0,1)";
  try {
    if (Array.isArray(array)) {
      if (array.length > 0) {
        if (array.length > 3) {
          color = `rgba(${array[0]}, ${array[1]}, ${array[2]}, ${array[3]})`;
        } else {
          color = `rgba(${array[0]}, ${array[1]}, ${array[2]}`;
        }
      }
    }
  } catch (error) {
    console.log(error, "while converting to rgbaString");
  }

  return color;
};

export const orderByPosition = (array = [], key = "position") => {
  return array.sort((a, b) => a[key] - b[key]);
};

export const generateRate = ({ condition, feedbackArray }) => {
  const negativeExists = some(condition, { negative: true });
  const neutralExists = some(condition, { neutral: true });
  if (feedbackArray.length < 1) {
    return "positive";
  } else if (negativeExists) {
    return "negative";
  } else if (neutralExists) {
    return "neutral";
  } else {
    return "positive";
  }
};

export const generateFinalPage = ({ feedbackArray }) => {
  if (feedbackArray.some((rate) => rate.conditionType === "negative"))
    return "negative";
  else if (feedbackArray.some((rate) => rate.conditionType === "neutral"))
    return "neutral";
  else return "positive";
};

export const generateRules = ({ component, errors, selectedLanguage }) => {
  // Dependencies
  const { type, name, required, min_length, max_length } = component || {};

  // Regex
  // const fullNameRegex = new RegExp(
  //   "^[^<>'\"/;~^&*-_+={}|?.,`%()$#!@$0-9]*([a-zA-Z]+)?$"
  // );
  // const fullNameRegex = new RegExp("[\u0621-\u064AA-Za-zäöüÄÖÜßəƏıIüÜĞğöÖşŞÇç ]+");
  // const fullNameRegex = new RegExp(/[*a-zA-Z]+$/);
  const mailRegex = new RegExp(
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );
  const phoneRegex = new RegExp("^[+]?[0-9]+$");

  const notAllowMinMaxRulesName = [
    "full_name",
    "phone_number",
    "email",
    "gender",
    "age_range",
  ];
  const notAllowMinMaxRulesType = [
    "file",
    "image",
    "audio",
    "date",
    "select",
    "multi-select",
  ];
  // Rules Array
  let rules = [];
  switch (type) {
    case "text": {
      // if (name === "full_name") {
      //   rules = [
      //     ...rules,
      //     {
      //       pattern: fullNameRegex,
      //       message: errors.full_name_format[selectedLanguage],
      //     },
      //   ];
      // }
      if (name === "email") {
        rules.push({
          pattern: mailRegex,
          message: errors.email_format[selectedLanguage],
        });
      }
      break;
    }
    case "number": {
      let pattern = new RegExp("^[0-9]+$");
      if (name === "phone_number") {
        pattern = phoneRegex;
      }
      rules.push({
        pattern: pattern,
        message: errors.number_format[selectedLanguage],
      });
      break;
    }
    default: {
      console.log(`No Rules for ${name}`);
      break;
    }
  }
  if (required) {
    rules.push({
      required: true,
      message: errors.required[selectedLanguage],
    });
  }
  if (
    !notAllowMinMaxRulesName.includes(name) &&
    !notAllowMinMaxRulesType.includes(type)
  ) {
    if (min_length) {
      rules.push({
        min: min_length,
        message: errors.too_short[selectedLanguage],
      });
    }
    if (max_length) {
      rules.push({
        max: max_length,
        message: errors.too_long[selectedLanguage],
      });
    }
  }

  return rules;
};
